import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../../../enums';

const Component = () => import('./BrandMenuWorksImport.vue');

export default {
  path: buildChildURL(
    GlobalMenuGroupsRoutePathNames.MENUWORKS,
    GlobalMenuGroupsRoutePathNames.MENUWORKS_UNIT_ID,
  ),
  name: GlobalMenuGroupsRouteNames.BRAND_MENUWORKS_IMPORT,
  component: Component,
} as RouteRecordRaw;
